import { Modal } from 'ncoded-component-library';
import { FC } from 'react';
import CreateLeadForm from './components/CreateLeadForm';
import { useTanstackMutation } from 'hooks';
import { queryClient } from 'react-query';
import toast from 'react-hot-toast';
import { createLead } from 'api/leads';
import CreatePersonalLeadForm from './components/CreatePersonalLeadForm/CreatePersonalLeadForm.component';
import { API_PATHS } from 'api';

type CreateLeadModalProps = {
  isOpen: boolean;
  onClose: () => void;
  campaignId: string;
  isPersonal: boolean;
};

const CreateLeadModal: FC<CreateLeadModalProps> = (props) => {
  const { isOpen, onClose, campaignId, isPersonal } = props;

  const { mutate: createLeadMutation, isPending } = useTanstackMutation({
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [`${isPersonal ? 'personal-' : ''}leads`],
      });
      queryClient.invalidateQueries({
        queryKey: [`${isPersonal ? 'personal-' : ''}tabs`],
      });

      toast.success(`Successfully created.`);
      onClose();
    },
    onError: (error) => {
      console.error(error);
      toast.error(`${error.message}`);
    },
  });

  const handleCreateLeadSubmit = (values: any) => {
    createLeadMutation({
      path: isPersonal
        ? API_PATHS.personalCampaigns.createPersonalLead(campaignId)
        : createLead(),
      method: 'post',
      body: isPersonal
        ? { ...values, keywords: values?.keywords?.join?.(', ') }
        : { campaignId, ...values },
    });
  };

  return (
    <Modal
      title={isPersonal ? 'Create lead' : 'Create Job Posting'}
      open={isOpen}
      onClose={onClose}
    >
      {isPersonal ? (
        <CreatePersonalLeadForm
          onSubmit={handleCreateLeadSubmit}
          submitInProgress={isPending}
        />
      ) : (
        <CreateLeadForm
          onSubmit={handleCreateLeadSubmit}
          submitInProgress={isPending}
        />
      )}
    </Modal>
  );
};

export default CreateLeadModal;
